import { render, staticRenderFns } from "./community_manager.vue?vue&type=template&id=2a009d9d"
import script from "./community_manager.vue?vue&type=script&lang=js"
export * from "./community_manager.vue?vue&type=script&lang=js"
import style0 from "./community_manager.vue?vue&type=style&index=0&id=2a009d9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports